import React, { Component } from 'react'
import { connect } from 'react-redux'
import OrdersTable from '../ulits/OrdersTable'

export class Orders extends Component {
  render() {
    const { orders } = this.props.order

    const ordersList = orders.sort((a, b) => b.date.toDate() - a.date.toDate())

    const ordersOptions = {
      dataSource: ordersList,
      locale: {emptyText: 'Geen bestellingen'}
    }

    return (
      <div className="orders-page">
        <OrdersTable {...ordersOptions} />
      </div>
    )
  }
}

const mapStateToProps =(state)=>({
  order: state.order
})


export default connect(mapStateToProps)(Orders)
